export const buttons = {
	Applepodcast: {
		label: 'Apple Podcast',
		type: 'Applepodcast',
		prefix: '',
	},
	Bandcamp: {
		label: 'Bandcamp',
		type: 'Bandcamp',
		prefix: '',
	},
	Clubhouse: {
		label: 'Clubhouse',
		type: 'Clubhouse',
		prefix: '',
	},
	Discord: {
		label: 'Discord',
		type: 'Discord',
		prefix: '',
	},
	Email: {
		label: 'Email Address',
		type: 'Email',
		prefix: '',
	},
	Facebook: {
		label: 'Facebook',
		type: 'Facebook',
		prefix: 'facebook.com/',
		domain: 'https://facebook.com/',
	},
	Github: {
		label: 'Github',
		type: 'Github',
		prefix: 'github.com/',
		domain: 'https://github.com/',
	},
	Instagram: {
		label: 'Instagram',
		type: 'Instagram',
		prefix: 'instagram.com/',
		domain: 'https://instagram.com/',
	},
	Itunes: {
		label: 'Itunes',
		type: 'Itunes',
		prefix: '',
		domain: '',
	},
	Ixigua: {
		label: 'Ixigua',
		type: 'Ixigua',
		prefix: '',
		domain: '',
	},
	Linkedin: {
		label: 'Linkedin',
		type: 'Linkedin',
		prefix: 'linkedin.com/',
		domain: 'https://linkedin.com/',
	},
	Mastadon: {
		label: 'Mastadon',
		type: 'Mastadon',
		prefix: '',
		domain: '',
	},
	Mixcloud: {
		label: 'Mixcloud',
		type: 'Mixcloud',
		prefix: 'mixcloud.com/',
		domain: 'https://mixcloud.com/',
	},
	Onlyfans: {
		label: 'Onlyfans',
		type: 'Onlyfans',
		prefix: '',
		domain: '',
	},
	Pinterest: {
		label: 'Pinterest',
		type: 'Pinterest',
		prefix: 'pinterest.com/',
		domain: 'https://pinterest.com/',
	},
	Rss: {
		label: 'Rss',
		type: 'Rss',
		prefix: '',
		domain: '',
	},
	Signal: {
		label: 'Signal',
		type: 'Signal',
		prefix: '',
		domain: '',
	},
	Snapchat: {
		label: 'Snapchat',
		type: 'Snapchat',
		prefix: '',
		domain: '',
	},
	Soundcloud: {
		label: 'Soundcloud',
		type: 'Soundcloud',
		prefix: 'soundcloud.com/',
		domain: 'https://soundcloud.com/',
	},
	Spotify: {
		label: 'Spotify',
		type: 'Spotify',
		prefix: '',
	},
	Strava: {
		label: 'Strava',
		type: 'Strava',
		prefix: '',
	},
	Telegram: {
		label: 'Telegram',
		type: 'Telegram',
		prefix: 't.me/',
		domain: 'https://t.me/',
	},
	Tiktok: {
		label: 'Tiktok',
		type: 'Tiktok',
		prefix: '@',
		domain: 'https://tiktok.com/@',
	},
	Twitch: {
		label: 'Twitch',
		type: 'Twitch',
		prefix: 'twitch.tv/',
		domain: 'https://www.twitch.tv/',
	},
	Twitter: {
		label: 'Twitter',
		type: 'Twitter',
		prefix: '@',
		domain: 'https://twitter.com/',
	},
	Vkontakte: {
		label: 'VKontakte',
		type: 'Vkontakte',
		prefix: 'vk.com/',
		domain: 'https://vk.com/',
	},
	Whatsapp: {
		label: 'Whatsapp',
		type: 'Whatsapp',
		prefix: 'wa.me/',
		domain: 'https://wa.me/',
	},
	Youtube: {
		label: 'Youtube',
		type: 'Youtube',
		prefix: 'youtube.com/',
		domain: 'https://youtube.com/',
	},
};
